import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AuditTaxConsulting from './pages/AuditTaxConsulting';
import CorporateTaxLanding from './pages/CorporateTaxLanding';
import ThankYou from './pages/ThankYou';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AuditTaxConsulting />} />
          <Route path="/corporate-tax" element={<CorporateTaxLanding />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App; 